import React, { useState } from 'react';
import styled from 'styled-components';
import { RigthBar } from './rigthBar';
import { Creation } from './creation';

interface formContentProps {
  

}

export const FormContent: React.FC<formContentProps> = () => {
    
    const [values, setValues] = useState<any>({});

    return (
        <Content>
          <Creation values={values} setValues={setValues}/>
          <RigthBar values={values} setValues={setValues}/>
        </Content>
    ); 
};


const Content = styled.div`
    width:100%
    height:100vh;
    display: flex;
    gap: 20px;
`;

 
